import { computed } from 'vue'
import { defaultPad } from './normalize/pad'
import { defaultSettings, normalizeSettings } from './normalize/settings'

export function makeGetters(token, state) {
  const isLoggedIn = computed(() => !!token.value)

  const user    = computed(() => state.value.user)
  const wallets = computed(() => state.value.wallets)
  const coins   = computed(() => state.value.coins)
  const mints   = computed(() => state.value.mints)
  const uiPluginInstallations = computed(() => state.value.uiPluginInstallations || [])
  const installationsReady = computed(() => state.value.installationsReady === true)
  const liveReady = computed(() => state.value.liveReady === true)
  const pnl     = computed(() => state.value.pnl || {})

  const settings = computed(() => state.value.settings || normalizeSettings())
  const filter   = computed(() => settings.value.filter || defaultSettings().filter)
  const launch   = computed(() => settings.value.launch || defaultSettings().launch)
  const trade    = computed(() => settings.value.trade || defaultSettings().trade)
  const autotrade = computed(() => settings.value.autotrade || defaultSettings().autotrade)
  const trades   = computed(() => settings.value.trades || defaultSettings().trades)
  const pad      = computed(() => state.value.pad || defaultPad())

  return { isLoggedIn, user, wallets, coins, mints, uiPluginInstallations, installationsReady, liveReady, pnl, settings, filter, launch, trade, autotrade, trades, pad }
}
